<template>

    <v-dropdown
        :icon="'fas fa-user'"
        :items="items"
        :actions="actions"
        :menu-position="'br'"
        :show-selected="false"
        @change="onChange"
    />

</template>

<script>

export default {

    props: {
        logoutOnly: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        items() {
            let items = [];
            items.push({
                key: 'name',
                value: this.user.name,
                icon: 'fas fa-user',
                type: 'primary',
                disabled: true,
            });
            if (this.logoutOnly) {
                return items;
            }
            items.push({
                key: 'account.user',
                value: this.$t('labels.profile'),
                icon: 'fas fa-address-card',
            });
            if (!this.user.is_sub_account) {
                items.push({
                    key: 'account.spaces',
                    value: this.$t('labels.spaces'),
                    icon: 'fas fa-rectangle-history',
                });
                items.push({
                    key: 'account.billing',
                    value: this.$t('labels.billing'),
                    icon: 'fas fa-receipt',
                });
                items.push({
                    key: 'referrals',
                    value: this.$t('labels.refer_and_earn'),
                    icon: 'fas fa-money-bill-trend-up',
                });
            }
            return items;
        },

        actions() {
            let actions = [];
            actions.push({
                key: 'logout',
                value: this.$t('labels.log_out'),
                icon: 'fas fa-right-from-bracket',
                type: 'danger'
            });
            return actions;
        },

    },

    methods: {

        onChange(e) {
            if (e.key === 'logout') {
                this.$store.commit('setModal', 'logout');
            } else {
                this.$router.push({ name: e.key }).catch(() => {});
            }
        },

    },

}

</script>
